import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
const StyledSkeletonParagraph = styled.div `
  height: 10px;
  border-radius: 5px;
  background-color: ${() => 'var(--bg-color-1)'};
  width: ${(props) => `${props.width}`};
  margin-bottom: 5px;
`;
const StyledSkeletonParagraphs = styled.div `
  width: 100%;
`;
export const SkeletonParagraph = (props) => {
    return (React.createElement(StyledSkeletonParagraphs, Object.assign({ className: cx('skeleton-paragraph', props.className), "data-role": "skeleton-paragraphs" }, props),
        React.createElement(StyledSkeletonParagraph, { className: "skeleton-paragraph", "data-role": "skeleton-paragraph", width: "30%" }),
        React.createElement(StyledSkeletonParagraph, { className: "skeleton-paragraph", "data-role": "skeleton-paragraph", width: "90%" }),
        React.createElement(StyledSkeletonParagraph, { className: "skeleton-paragraph", "data-role": "skeleton-paragraph", width: "20%" })));
};
